import { RotateCw } from 'lucide-react';
import { triggerHaptic } from '../../lib/haptics';
import { Pill, PRESS } from './insightsUi';

export interface InsightSummaryCardProps {
  headline: string;
  summary: string;
  /** True when the text is the on-device template sentence rather than the AI's. */
  calculated: boolean;
  loading: boolean;
  onRetry: () => void;
}

export function InsightSummaryCard({ headline, summary, calculated, loading, onRetry }: InsightSummaryCardProps) {
  if (loading) {
    return (
      <div
        className="rounded-2xl bg-white dark:bg-zinc-900 p-4 space-y-2.5"
        role="status"
        aria-live="polite"
        aria-label="Generating your summary"
      >
        <div className="h-4 w-1/2 rounded-md bg-slate-200 dark:bg-zinc-800 animate-pulse motion-reduce:animate-none" />
        <div className="h-3.5 w-full rounded-md bg-slate-200 dark:bg-zinc-800 animate-pulse motion-reduce:animate-none" />
        <div className="h-3.5 w-11/12 rounded-md bg-slate-200 dark:bg-zinc-800 animate-pulse motion-reduce:animate-none" />
        <div className="h-3.5 w-2/3 rounded-md bg-slate-200 dark:bg-zinc-800 animate-pulse motion-reduce:animate-none" />
      </div>
    );
  }

  return (
    <div className="rounded-2xl bg-white dark:bg-zinc-900 p-4">
      <p className="text-[0.9375rem] leading-snug text-slate-800 dark:text-zinc-200">
        <span className="font-semibold text-slate-950 dark:text-white">{headline}</span> {summary}
      </p>
      {calculated && (
        <div className="mt-3 flex items-center justify-between gap-2">
          <Pill tone="slate">Calculated</Pill>
          <button
            type="button"
            onClick={() => {
              triggerHaptic('light');
              onRetry();
            }}
            className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-semibold text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-500/15 ${PRESS}`}
          >
            <RotateCw className="w-3.5 h-3.5" aria-hidden="true" />
            Try again
          </button>
        </div>
      )}
    </div>
  );
}
